import { render, staticRenderFns } from "./AffordableRents.vue?vue&type=template&id=0db6a2b1&scoped=true&"
import script from "./AffordableRents.vue?vue&type=script&lang=js&"
export * from "./AffordableRents.vue?vue&type=script&lang=js&"
import style0 from "./AffordableRents.vue?vue&type=style&index=0&id=0db6a2b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6a2b1",
  null
  
)

export default component.exports